import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PatientImg from "../../../Assets/Images/PatientImg.png";
import Edit from "../../../Assets/Icons/Edit.png";
import StarGrey from "../../../Assets/Icons/Star_Grey.svg";
import StarYellow from "../../../Assets/Icons/Star.svg";
// import sendMessage from "../../../Assets/Icons/sendMessage.svg";
import sendMessage from "../../../Assets/Icons/sendMessage1.svg";
// import viewProfile from "../../../Assets/Icons/profile.svg";
import viewProfile from "../../../Assets/Icons/profile-green.svg";
import VisitModal from "../Modal/VisitModal";
import { MessageToPatient } from "../Modal/MessageToPatient";
import { usePatientContext } from "../../../Context/PatientContext";
import { getAge, getGenderCode } from "../../../Helpers/index";

import "./style.css";
import EditPatientModal from "../Modal/EditPatientDetails";

/**
 * Patient Info Component containing basic information about patient & buttons for sending message & starting new visit record
 * @param {object} patientInfo - Information about the patient - default params for now
 */
const PatientInfo = ({ screen }) => {
  //States for handling modals
  const [isInitiateNewVisitModalOpen, setInitiateNewVisitModalOpen] =
    useState(false);
  const [isMessageToPatientModalOpen, setMessageToPatientModalOpen] =
    useState(false);
  const [isEditPatientDetailsModalOpen, setEditPatientDetailsModalOpen] =
    useState(false);

  const { patientDetails } = usePatientContext();

  const navigate = useNavigate();
  const openInitiateNewVisitModal = () => {
    setInitiateNewVisitModalOpen(true);
  };

  const openMessageToPatientModal = () => {
    setMessageToPatientModalOpen(true);
  };

  return (
    // patient info frame - containing patient info description frame and button frame
    <div className="patient-info-frame">
      {/* patient info description frame */}
      <div className="patient-info-desc-frame">
        <img className="patient-img" alt="patient_image" src={PatientImg} />
        <div className="patient-details-main-frame">
          <div className="patient-details-frame-common">
            <div className="patient-desc">
              <div className="patient-details-main-frame">
                <div className="patient-name-lg">
                  <h4 className="h4-400 dark-grey">
                    {patientDetails.firstName} {patientDetails.lastName}
                  </h4>
                </div>
              </div>
              <div className="patient-type-btn">
                <div
                  className={`patient-type-btn-frame ${
                    patientDetails.type === "Primary"
                      ? "patient-type-primary"
                      : "patient-type-referred"
                  }`}
                >
                  <div className="patient-type-text">
                    <p className="body2 dark-grey">{patientDetails.type}</p>
                  </div>
                </div>
              </div>
              <img
                className="edit-icon"
                alt="edit-icon"
                src={Edit}
                onClick={() => setEditPatientDetailsModalOpen(true)}
              />
            </div>
            <div className="patient-details-main-frame">
              <p className="dark-grey">
                Patient ID: {patientDetails.patientId} |{" "}
                {patientDetails.dateOfBirth &&
                  `Age: ${getAge(patientDetails.dateOfBirth)}`}{" "}
                {getGenderCode(patientDetails.gender)}
              </p>
              {/* {patientDetails.isStarred && ( */}
              <img
                src={patientDetails.isStarred ? StarYellow : StarGrey}
                className="star-instance"
                alt="star-icon"
              />
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
      {/* patient details button frame */}
      <div className="patient-details-button-frame">
        <div className="patient-details-frame-common">
          <div className="patient-details-button-frame">
            {/* Disabled for phase 1 */}
            {/* Initiate new visit button */}
            {/* <div className="newvisit-btn" onClick={openInitiateNewVisitModal}>
              <div className="newvisit-btn-text">Initiate New Visit</div>
            </div> */}
            {/* send message icon */}
            {screen === "details" && (
              <div className="patient-details-icon-frame">
                <img
                  className="sendmsg-btn"
                  alt="send-message-icon"
                  src={sendMessage}
                  onClick={() =>
                    navigate(`/dashboard/messages/${patientDetails._id}`)
                  }
                />
              </div>
            )}
            {/* View profile icon */}
            {screen === "messages" && (
              <div className="patient-details-icon-frame">
                <img
                  className="sendmsg-btn"
                  alt="view-profile-icon"
                  src={viewProfile}
                  onClick={() => navigate(`/patient/${patientDetails._id}`)}
                />
              </div>
            )}

            {/* View profile button */}
            {/* {screen === "messages" && (
              <div
                className="newvisit-btn"
                onClick={() => navigate(`/patient/${patientDetails._id}`)}
              >
                <div className="newvisit-btn-text">View Profile</div>
              </div>
            )} */}
          </div>
        </div>
      </div>
      {/* Show Edit Patient Details modal when edit button is clicked */}
      {isEditPatientDetailsModalOpen && (
        <EditPatientModal
          type="profile"
          isOpen={isEditPatientDetailsModalOpen}
          onClose={() => setEditPatientDetailsModalOpen(false)}
          patientInfo={PatientInfo}
        />
      )}
      {/* Show Initiate New Visit Modal when Initiate New visit button is clicked */}
      {isInitiateNewVisitModalOpen && (
        <VisitModal
          type="initiate"
          isOpen={isInitiateNewVisitModalOpen}
          onClose={() => setInitiateNewVisitModalOpen(false)}
          patientInfo={PatientInfo}
        />
      )}
      {/* Show Send Message Modal when Initiate Send Message button is clicked*/}
      {isMessageToPatientModalOpen && (
        <MessageToPatient
          onClose={() => setMessageToPatientModalOpen(false)}
          patientInfo={PatientInfo}
        />
      )}
    </div>
  );
};

export default PatientInfo;
